import * as React from "react";

const BubbleEmptyLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" focusable="false" viewBox="0 -960 960 960">
            <path fill="none" d="M-2-2h24v24H-2z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="m240-240-92 92q-19 19-43.5 8.5T80-177v-623q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240Zm-34-80h594v-480H160v525l46-45Zm-46 0v-480 480Z"
            />
        </svg>
    );
};

export default React.memo(BubbleEmptyLeft);
